import { z } from 'zod';

export const mercuryContentTypeSchema: z.ZodNativeEnum<{
	readonly FocusArea: 'focus-area';
	readonly Ask: 'ask';
	readonly Organization: 'organization';
	readonly Risk: 'risk';
}> = z.nativeEnum({
	FocusArea: 'focus-area',
	Ask: 'ask',
	Organization: 'organization',
	Risk: 'risk',
} as const);
